/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable react/prop-types */
import { unwrapResult } from '@reduxjs/toolkit'
import { Modal, ModalProps, Typography, Popover, Row, Col, Button, notification } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectCredentials, selectInsuranceArray } from '../../../app/applicationSlice'
import { RootDispatch } from '../../../app/store'
import { MedicalItem } from '../../../models/material'
import { List } from '../../../models/page'
import { MedicalListBody } from '../../../services/commodity'
import { getMedicalListAsync, getZjWbCodes, saveMedicare } from '../commoditySlice'
import { AGColumns } from './MedicalColumns'
import { MedicalQuery } from './MedicalQuery'
import { getPageColumnListAsync, getSubmitPageColumnListAsync } from '../../transactionQuery/transactionQuerySlice'
import SimpleAgGrid from '../../../compnents/simpleTable/SimpleAgGrid'
import { getSortColumnList } from '../../../models/common'
import { selectSettings } from '../../user/setting/settingSlice'
import { Checks } from '../../../models/setting'
const { Text } = Typography
export interface MedicalModalProps {
  componentItem: any
  isSPGL?: any
  onRecord?: (item: MedicalItem) => void
  isTreatmentCatalog?: boolean
}

export const MedicalModal: React.FC<ModalProps & MedicalModalProps> = ({
  onOk,
  onCancel,
  visible,
  isSPGL = false, //商品管理页面标志
  componentItem,
  onRecord = () => { },
  isTreatmentCatalog,
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const insuranceArray = useSelector(selectInsuranceArray)

  const credentials = useSelector(selectCredentials)

  const settings = useSelector(selectSettings)

  const [pageLoading, setPageLoading] = useState<any>(false)

  const [pageSelections, setPageSelections] = useState<any>({})

  // 所有的列表
  const listData: any = [
    {
      headerName: '',
      field: 'checkbox',
      checkboxSelection: true,
      headerCheckboxSelection: true,  // 启用表头复选框（全选功能）
      width: 50,
      minWidth: 50,
      pinned: 'left',// 将列固定在左侧
      lockPosition: "left", // 锁定列位置，防止列移动
      suppressMovable: true, // 防止列被拖动
      resizable: false, //防止列宽被调整
      visible: true,
    },
    {
      headerName: '序号',
      width: 60,
      minWidth: 60,
      field: 'index',
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '售价',
      field: 'medChrgitmType',
      minWidth: 190,
      visible: true,
    },
    {
      headerName: '国家医保编码',
      field: 'hiListCode',
      minWidth: 200,
      visible: true,
    },
    // 江苏 省市编码  
    {
      headerName: '省市编码',
      field: 'proviceHilistCode',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '医保类型',
      field: 'insuAdmdvs',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '医保项目名称',
      field: 'hilistName',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '医保规格',
      field: 'spec',
      minWidth: 140,
      visible: true,
    },
    {
      headerName: '医保单位',
      field: 'pacunt',
      minWidth: 90,
      visible: true,
    },
    {
      headerName: '包装材质',
      field: 'pacmatl',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '医保剂型',
      field: 'dosformName',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '批准文号',
      field: 'aprvno',
      minWidth: 160,
      visible: true,
    },
    {
      headerName: '医保厂家',
      field: 'prodentpName',
      minWidth: 200,
      visible: true,
    },
    {
      headerName: '转化比',
      field: 'conversion',
      minWidth: 80,
      visible: true,
    },
    {
      headerName: '型号',
      field: 'specMol',
      minWidth: 90,
      visible: true,
    },
    {
      headerName: '医保限价',
      field: 'hilistPricUplmtAmt',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '限价类型',
      field: 'hilistLmtpricType',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '甲乙分类',
      field: 'chrgitmLv',
      minWidth: 90,
      visible: true,
    },
    {
      headerName: '是否报销',
      field: 'isCouldBx',
      minWidth: 90,
      visible: true,
    },
    {
      headerName: '目录文件描述',
      field: 'trtItemDscr',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '二级伤残默认自付比例',
      field: 'disabled',
      minWidth: 190,
      visible: true,
    },
    {
      headerName: '城乡居民默认自付比例',
      field: 'residents',
      minWidth: 190,
      visible: true,
    },
    {
      headerName: '离休人员默认自付比例',
      field: 'retired',
      minWidth: 190,
      visible: true,
    },
    {
      headerName: '城乡职工默认自付比例',
      field: 'workers',
      minWidth: 190,
      visible: true,
    },
    {
      headerName: '备案公司',
      field: 'regerName',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '备注',
      field: 'memo',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '市场状态',
      field: 'mktStas',
      minWidth: 90,
      visible: true,
    },
  ]?.map((v, index) => {
    return {
      ...v,
      index: index + 1,
    }
  })

  const allData = listData

  // 默认要展示的列的值
  const selectColumns = allData?.filter((v: any) => v.visible)?.map((item: any) => item.field) || []

  const [allColumnList, setAllColumnList] = useState<any[]>([]) //筛选列所有的数据

  const [columnQueryFilterList, setColumnQueryFilterList] = useState<any[]>([])

  // 筛选列所有的数据
  const [filterColumnList, setFilterColumnList] = useState<any[]>([])

  const [filterSelectList, setFilterSelectList] = useState<any[]>([]) //筛选列所有的数据

  const [queries, setQueries] = useState<MedicalListBody>({
    current: 1,
    size: 10,
    // itemNameKeyWorld: componentItem?.name,
  })

  const [refresh, setrefresh] = useState(false)

  const [data, setData] = useState<List<any>>()

  const [codes, setCodes] = useState<any>()

  const [selectIds, setSelectIds] = useState<any>([])

  const [tempIdsList, setTempIdsList] = useState<any>([])

  const [buttonLoading, setButtonLoading] = useState<any>(false)

  const priceMapRef = React.useRef<Record<string, string>>({}) // 售价跨页记忆，用 ref 避免 setState 导致 Input 失焦

  // const rowSelection = {
  //   onChange: (selectedRowKeys: React.Key[], selectedRows: any) => {
  //     data?.list.forEach((item: any) => {
  //       item.sta = true
  //     })
  //     selectedRows.forEach((item: any) => {
  //       item.sta = false
  //     })
  //     setTempIdsList(selectedRows)
  //     setSelectIds([...selectedRowKeys])
  //   },
  // }

  useEffect(() => {
    if (JSON.stringify(pageSelections) != '{}') {
      const derivedSelectedKeys = Object.values(pageSelections).flat()
      const selectedRowIds = derivedSelectedKeys.map((row: any) => row?.rid)
      data?.list.forEach((item: any) => {
        item.sta = true
      })
      derivedSelectedKeys.forEach((item: any) => {
        item.sta = false
      })
      setSelectIds(selectedRowIds || [])
      setTempIdsList(derivedSelectedKeys)
    }
  }, [pageSelections])

  useEffect(() => {
    if (!selectIds?.length) {
      setPageSelections({})
    }
  }, [selectIds]);

  useEffect(() => {
    if (allColumnList?.length) {
      // 1.江苏医保不展示包含自付比例的  2.其余不展示 省市编码
      const insuranceListData = insuranceArray[0]?.insuranceCode == 'JIANGSU' ? allColumnList?.filter((t: any) => String(t.title).indexOf('自付比例') == -1) : allColumnList?.filter((v: any) => v.field != 'proviceHilistCode')
      const columnData = isSPGL ? (
        insuranceListData
      ) : (
        insuranceListData?.filter((v: any) => v.field != 'checkbox' && v.field != 'medChrgitmType')
      )
      setColumnQueryFilterList(columnData)
    }
  }, [allColumnList])

  const submitPageList = (data: any) => {
    const params = {
      pageName: 'medicalModal',
      configJson: JSON.stringify(data),
    }
    dispatch(getSubmitPageColumnListAsync({
      ...params,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        getPageColumnList(v?.id)
      })
  }

  const getPageColumnList = (id?: any) => {
    dispatch(getPageColumnListAsync({
      id: id ? id : undefined,
      pageName: 'medicalModal',
    }))
      .then(unwrapResult)
      .then((v: any) => {
        const data: any = v?.configJson ? JSON.parse(v?.configJson) : []
        const filterList = data?.filter((n: any) => n?.visible)
        const columns = filterList?.map((n: any) => n?.field)
        const resetData = data?.map(((v: any) => {
          const sameFileds = allData?.find((item: any) => item?.field == v?.field)
          return {
            ...v,
            minWidth: sameFileds?.minWidth || v?.minWidth,
            width: sameFileds?.width || v?.width,
            headerName: sameFileds?.headerName || v?.headerName,
          }
        }))
        // 所有的数据
        setAllColumnList(data?.length ? resetData : allData)
        // 筛选后存在后端的数据
        setFilterColumnList(filterList?.length ? filterList : allData)
        // 选中的值
        setFilterSelectList(columns?.length ? columns : selectColumns)
      })
      .catch(() => {
        setAllColumnList(allData)
        setFilterColumnList(allData)
        setFilterSelectList(selectColumns)
      })
  }

  useEffect(() => {
    if (visible) {
      setPageLoading(true)
      getPageColumnList()
      dispatch(
        getMedicalListAsync({
          insuranceCode:
            componentItem?.insuranceCode || insuranceArray[0]?.insuranceCode,
          billingCategory: componentItem?.billingCategory,
          itemNameKeyWorld:
            componentItem?.name == '新增' ? '' : componentItem?.name,
          prodentpNameKeyWorld: componentItem?.tenantSupplierName,
          prodConvrat: componentItem?.transitionScale,
          aprvno: componentItem?.approvalNumber,
          insuAdmdvs: credentials
            ? credentials?.insuranceArray[0]?.insuranceCuntryCode
            : '',
          ...queries,
        })
      )
        .then(unwrapResult)
        .then((res: List<any>) => {
          // 二次处理，合并重复项目
          const rres = res.list;
          const mergedData: any[] = [];
          const mergedMap: { [key: number]: any } = {};

          for (let i = 0; i < rres.length; i++) {
            const row = rres[i];
            const hiListCode = row.hiListCode;

            if (mergedMap[hiListCode]) {
              Object.keys(row).forEach((key) => {
                if (key !== 'hiListCode' && mergedMap[hiListCode][key] !== row[key]) {
                  mergedMap[hiListCode][key] += `###${row[key]}`;
                }
              });
            } else {
              mergedMap[hiListCode] = { ...row };
              mergedData.push(mergedMap[hiListCode]);
            }
          }

          const dat: any = {
            ...res,
            list: res?.list?.map((item: any) => {
              return {
                ...item,
                sta: true,
                sellingPrice: priceMapRef.current[item.rid] ?? item.sellingPrice,
              }
            })
          }
          setData(dat);
        })
        .finally(() => {
          setPageLoading(false)
        })
    }
  }, [visible, queries])

  useEffect(() => {
    setrefresh(!!visible)
    return () => {
      if (visible) {
        setQueries({
          ...queries,
          current: 1,
          size: 10,
        })
      } else {
        setSelectIds([])
        setTempIdsList([])
        setPageSelections({})
        priceMapRef.current = {}
        setData(undefined)
      }
    }
  }, [visible])

  return (
    <Modal
      title={isSPGL ? '医保目录库' : `${componentItem?.name}-医保目录查询`}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      width={1500}
      footer={null}
      bodyStyle={{
        height: 670,
        padding: '6px 15px 10px 15px',
        overflowY: 'auto',
      }}
    >
      {/* 0512通用名修改 药品名称->通用名 通用名->商品名*/}
      {settings?.[Checks.MLKG] == 1 ? 
      (componentItem?.billingCategory == '01' || componentItem?.billingCategory == '02') && componentItem?.name && "通用名：" + (componentItem?.name || '-') + "，商品名：" + (componentItem?.genericName || '-') + "，规格：" + (componentItem?.packSpec || '-')  + "，批准文号：" + (componentItem?.approvalNumber || '-')  + "，生产厂家：" + (componentItem?.tenantSupplierName || '-') :
      (componentItem?.billingCategory == '01' || componentItem?.billingCategory == '02') && componentItem?.name && "通用名：" + (componentItem?.name || '-') + "，商品名：" + (componentItem?.genericName || '-') + "，账簿单位：" + (componentItem?.accountUnit || '-') + "，包装规格：" + (componentItem?.packSpec || '-') + "，批准文号：" + (componentItem?.approvalNumber || '-') + "，转换比：" + (componentItem?.transitionScale || '-') + "，生产厂家：" + (componentItem?.tenantSupplierName || '-') 
      }
      <MedicalQuery
        isSPGL={isSPGL}
        filterColumn={columnQueryFilterList}
        filterSelectList={filterSelectList}
        submitPageList={((v) => {
          submitPageList(v)
          setAllColumnList(v)
        })}
        BillingCategory={componentItem?.billingCategory}
        KeyWorld={componentItem?.name == '新增' ? '' : componentItem?.name}
        ProdentpNameKeyWorld={componentItem?.billingCategory == '03' ? '' : componentItem?.tenantSupplierName}
        TransitionScale={componentItem?.billingCategory == '03' ? '' : componentItem?.transitionScale}
        Aprvno={componentItem?.billingCategory == '03' ? '' : componentItem?.approvalNumber}
        refresh={refresh}
        onValueChange={(value) => {
          setQueries({ ...queries, ...value, current: 1 })
        }}
        isTreatmentCatalog={isTreatmentCatalog}
      />
      <Text italic>
        *双击一条医保项目, 完成匹配 (
        <span style={{ color: '#15ad31' }}> 绿色项目</span>)为医保甲类,(
        <span style={{ color: '#FA8714' }}> 橙色项目</span>)为医保乙类, (
        <span style={{ color: '#2A7CF6' }}> 蓝色项目</span>
        )为医保丙类,黑色项目为自费或只能历年支付的项目
        <Popover
          placement='bottomLeft'
          content={
            <div>
              <p>
                1.医保国码目录数据庞大，建议您在匹配时尽量补全上方的搜索条件以达到精确查询的效果。
              </p>
              <p>
                2.一般情况下，通过{' '}
                <span style={{ color: '#117dd0', fontWeight: 'bold' }}>
                  项目名称 + 厂家 + 转换比
                </span>{' '}
                即可查询到精确的信息。
              </p>
              <p>
                3.在{' '}
                <span style={{ color: '#117dd0', fontWeight: 'bold' }}>
                  项目名称 + 厂家 + 转换比 + 规格
                </span>{' '}
                都能对应上时，优先选择绿色的项目，双击即可完成匹配。
              </p>
              <p>
                4.部分目录的{' '}
                <span style={{ color: '#117dd0', fontWeight: 'bold' }}>
                  医保限价
                </span>{' '}
                会存在{' '}
                <span style={{ color: '#117dd0', fontWeight: 'bold' }}>
                  地市限价
                </span>{' '}
                与{' '}
                <span style={{ color: '#117dd0', fontWeight: 'bold' }}>
                  省医保限价
                </span>{' '}
                不一致的情况，此时系统会优先返回{' '}
                <span style={{ color: '#117dd0', fontWeight: 'bold' }}>
                  地市限价
                </span>
                ，您可以通过“医保类型”列做出判断。
              </p>
              <p>
                5.如您发现地市限价信息不正确，也可与我们服务人员联系更新或补充。
              </p>
            </div>
          }
          trigger='click'
        >
          <a style={{ marginLeft: '10px' }}>查看匹配教程</a>
        </Popover>
      </Text>
      <div style={{ height: '550px' }}>
        <SimpleAgGrid
          page={{
            size: queries.size || 10,
            current: queries.current || 1,
            total: data?.total || 0,
            items: data?.list || [],
          }}
          isLoading={pageLoading}
          pagination={true}
          pageKey={'medicalModal'}
          rowSelection="multiple"
          selectedRowKeys={selectIds}
          rowKey={(row: any) => row.rid}
          getRowId={(data: any) => data?.rid}
          suppressRowClickSelection={true}
          //跨页勾选
          onSelectionChange={(selectedRows: any, selectedNodes: any) => {
            // 更新当前页面的选中状态
            const currentPage: any = queries.current;
            setPageSelections((prev: any) => ({
              ...prev,
              [currentPage]: selectedRows
            }));
          }}
          column={
            AGColumns(
              () => { },
              (queries.size || 10) * ((queries.current || 1) - 1),
              selectIds,
              isSPGL,
              columnQueryFilterList,
              (rid: any, value: any) => {
                priceMapRef.current = { ...priceMapRef.current, [rid]: value }
                data?.list.forEach((item: any) => {
                  if (rid == item?.rid) {
                    item.sellingPrice = value
                  }
                })
              }
            )?.filter((item: any) => filterSelectList?.includes(item.field))
          }
          onChangePage={(current, size) => {
            setQueries({
              ...queries,
              current,
              size,
            })
          }}
          onRowDoubleClick={(event: any) => {
            const d = event?.data
            dispatch(getZjWbCodes(d?.hilistName))
              .then(unwrapResult)
              .then((v: any) => {
                setCodes(v)
              })
            onRecord({
              ...d,
              mnemonicCode: codes?.pinYin,
              wubiCode: codes?.wuBi,
            })
          }}
          onColumnResized={(v) => {
            return
          }}
          onColumnMoved={(v) => {
            // setPageLoading(true)
            const sortList = getSortColumnList(allColumnList, v);
            submitPageList(sortList)
            setAllColumnList(sortList)
          }}
        />
      </div>
      {isSPGL && <Row gutter={20}>
        <Col span={12}>
          <Button
            type='primary'
            htmlType='submit'
            style={{ float: 'right' }}
            loading={buttonLoading}
            onClick={() => {

              const arrParams = tempIdsList.map((item: any) => {
                return {
                  hilistCode: item.hiListCode,
                  rid: item.rid,
                  sellingPrice: item.sellingPrice,
                }
              })
              const reg = /^([0](\.\d{1,4}))$|^([1-9][0-9]*(\.\d{1,4})?)$/ //校验输入的值
              let tempFlag = false
              arrParams.forEach((item: any) => {
                if (!reg.test(item.sellingPrice)) {
                  tempFlag = true
                }
              })
              if (!tempFlag) {
                setButtonLoading(true)
                dispatch(saveMedicare([...arrParams]))
                  .then(unwrapResult)
                  .then((res: any) => {
                    notification.open({ message: res, duration: 5 })
                    onOk && onOk(res)
                    setSelectIds([])
                    setButtonLoading(false)
                  })
                  .catch(() => {
                    setButtonLoading(false)
                  })
              } else {
                notification.error({ message: '请输入正确的售价', duration: 3 })
              }
            }}
          >
            导入{selectIds.length != 0 ? `(${selectIds.length})` : ''}
          </Button>
        </Col>
        <Col span={12}>
          <Button
            onClick={onCancel}
          >
            取消
          </Button>
        </Col>
      </Row>}
    </Modal>
  )
}
